// Web implementation: map SF Symbol-like names to MUI icons
import React from 'react';
import type { CSSProperties } from 'react';
import HomeIcon from '@mui/icons-material/Home';
import SendIcon from '@mui/icons-material/Send';
import CodeIcon from '@mui/icons-material/Code';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import EventIcon from '@mui/icons-material/Event';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import GroupsIcon from '@mui/icons-material/Groups';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import PanToolIcon from '@mui/icons-material/PanTool';
import CloseIcon from '@mui/icons-material/Close';
import PhotoIcon from '@mui/icons-material/Photo';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckIcon from '@mui/icons-material/Check';
import NotificationsIcon from '@mui/icons-material/Notifications';

const ICONS = {
  'house.fill': HomeIcon,
  'paperplane.fill': SendIcon,
  'chevron.left.forwardslash.chevron.right': CodeIcon,
  'chevron.right': ChevronRightIcon,
  'chevron.left': ChevronLeftIcon,
  calendar: EventIcon,
  'bubble.right.fill': ChatBubbleIcon,
  'person.3.fill': GroupsIcon,
  'gift.fill': CardGiftcardIcon,
  'ellipsis.horizontal': MoreHorizIcon,
  'ellipsis': MoreHorizIcon,
  'hand.raised.fill': PanToolIcon,
  'xmark': CloseIcon,
  'photo': PhotoIcon,
  'camera': PhotoCameraIcon,
  'checkmark.circle.fill': CheckCircleIcon,
  'arrow.left': ArrowBackIcon,
  'checkmark': CheckIcon,
  'bell': NotificationsIcon,
} as const;

export type IconSymbolName = keyof typeof ICONS;

const resolveColor = (color?: string): string | undefined => {
  if (!color) return undefined;
  if (color.startsWith('$')) return `var(--${color.slice(1)})`;
  return color;
};

export function IconSymbol({
  name,
  size = 24,
  color,
  style,
}: {
  name: IconSymbolName;
  size?: number;
  color?: string;
  style?: CSSProperties;
}) {
  const Cmp = ICONS[name];
  if (!Cmp) return null;
  return (
    <Cmp
      style={{
        color: resolveColor(color),
        fontSize: size,
        ...(style as any),
      }}
    />
  );
}
